import '../music.css';
import { Layout, Select,Tooltip, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space, Dropdown ,notification,AutoComplete } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,CalendarOutlined,EditOutlined,SaveOutlined, UserOutlined,TagsOutlined,TeamOutlined,HomeOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,ReadOutlined,DownloadOutlined,QrcodeOutlined,LogoutOutlined,BarChartOutlined } from '@ant-design/icons';
import moment from 'moment'
import { Document, Page } from 'react-pdf';
import { useLocation } from 'react-router-dom'
import DownloadLink from "react-download-link";
import axios from "axios";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import countries from '../static/json/countries.json'
import Navbar from '../components/NavBar' 

class Playslist extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;

    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
        plays:[],
      fileList: [],
      authors:[],
      showArticle:false,
      record:null,
      numPages:0,
      editDataIndex:"",
      editIndex:-1,
      edit:false,
      editAuthorIndex:[],
      editAuthor: null,
      categoryChanged:"",
      conc:[],
      filteredInfo:[],
      makeGenreReport:false,
      reportGenre:'Novela',
      reportCountry:null,
      makeCountryReport:false
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/musica/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }

  onClickArticle = record  => {
    console.log(record)
        this.setState({showArticle:true,record:record});
  };

 
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};

  onClickEditPlay(record){
    console.log(record)
    console.log("PAPILLA")
        this.setState({edit:true,record:record});
  };
  onChangeSelect(value){
    console.log("CGHAAAAAAA",value)
    this.setState({categoryChanged:value})
  }
  // onClickEdit=(index,dataIndex)=>{
  //   // if(field=="title"){
  //   //   this.setState({editTitle:true})
  //   // }
  //   // if(field=="author"){
  //   //   this.setState({editAuthor:true})
  //   // }
  //   // if(field=="category"){
  //   //   this.setState({editCategory:true})
  //   // }
  //   // if(field=="pseudo"){
  //   //   this.setState({editPseudo:true})
  //   // }
  //   console.log(index)
  //   console.log(dataIndex)
  //   this.setState({editIndex:index,editDataIndex:dataIndex, edit:true})
  // }
  onClickEditAuthor=(index,authorIndex, author)=>{
    // if(field=="title"){
    //   this.setState({editTitle:true})
    // }
    // if(field=="author"){
    //   this.setState({editAuthor:true})
    // }
    // if(field=="category"){
    //   this.setState({editCategory:true})
    // }
    // if(field=="pseudo"){
    //   this.setState({editPseudo:true})
    // }
    console.log(index)
    console.log(authorIndex)
    this.setState({editIndex:index,editAuthorIndex:authorIndex, edit:true, editDataIndex:'author', editAuthor:author})
  }

  handleTableChange = (pagination, filters, sorter, extra) => {
    console.log('Various parameters', extra.currentDataSource);
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }

  

  getAutocomplete = (dataIndex) =>{
    console.log(this.codes)
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

    else if (dataIndex== "category"){
      return this.categories
    }
    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
   getAuthors(auth){
     var authors = []
     for (var i in auth){
      authors.push({id:i,
        name: auth[i]["nombre_completo"]} )
     }
    return authors

  }
  getAuthorsStr(auth){
    var authors = []
    for (var i in auth){
     authors.push( auth[i]["nombre_completo"])
     
    }
   return authors

 }
 getCountryName(country){
  for(var c in  countries["countries"]){
    if (countries["countries"][c]["code"]==country)
      return countries["countries"][c]["name_es"]
  }
  return "No name"
}
  async componentDidMount() {
    const response = await fetch('https://back.premiocasa.cult.cu/api/musica/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }

    
   
    
    const json_conc = [].concat.apply([],json.map(play=> {return play.conc})) 
    
    console.log(json)
    
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    this.countries = new Set();
    
    const Moment = require('moment');
    
    for(var i in json){
      var item = json[i];
      // const pdf = await fetch('/api/file/'+i);
      console.log(item)
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= this.getAuthors(item.conc)
      var a= this.getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      
      var authorStr = this.getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.codes.add(item.code);
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo??'')
      console.log("ID")
      console.log(i)
      this.countries.add(this.getCountryName(item.conc[0].pais))
      const year = date.split('-')[2]
      console.log("YEAR",year)
      data.push(
          { 
              id : item.id,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              pseudo: item.pseudonimo??'',
              code:year+'_'+item.id,
              conc:item.conc,
              // date:'',
              pdf:item.pdf,
              edit:''
          });
    };

    var data_conc = []

    this.names = new Set();
    this.emails = new Set();
    
    for(var i in json_conc){
      var item = json_conc[i];
      
      this.names.add(item.nombre_completo)
      this.emails.add(item.email)
      
      data_conc.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: item.pais,
              countryName: this.getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,

              // date:new Moment(item.start_publication).format('YYYY-MM-DD'),
              email: item.email,
          });
    };
    this.setState({ plays: data , conc:data_conc, filteredInfo:data});
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
   
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
  }

  async onClickSaveAuthor(field, index,key,author){
    console.log("AQUIII")
    console.log(field)
    console.log(author)
    var options = {
       method: "patch",
       credentials: "same-origin",
       headers: {
         "Authorization": localStorage.getItem("Authorization") ,
         "Accept": "application/json",
         "Content-Type": "application/json"},
      
     }
     var editedAuthor = {
       nombre_completo: document.getElementById("author"+index).value
     }
     // id : i,
     // title : item.titulo,
     // author: author ,
     // date:date,
     // pseudo: item.pseudonimo,
     // code:item.code,
     // // date:'',
     // category:item.genero.nombre,
     // pdf:item.pdf
     // console.log(document.getElementById("inputPseudo").value)
    //  console.log(author.conc[key].nombre)
    //  console.log("author"+index)
    //  author.conc[key].nombre=
    //  var playChanged={}
    
    //    playChanged={
    //      conc: author.conc
    //  }
    
     
     await axios.patch(`https://back.premiocasa.cult.cu/api/concursantes/${key}/`, editedAuthor, options)
     .then(
       (response) => {
         console.log(response);
        if(response.status === 200)
          window.location.reload();
       },
       (error) => {
         console.log(error);
       }
     ).catch((err) => console.log(err))
     
   }
  readTextFile(file)
{
    var rawFile = new XMLHttpRequest();
    rawFile.open("GET", file, false);
    rawFile.onreadystatechange = function ()
    {
        if(rawFile.readyState === 4)
        {
            if(rawFile.status === 200 || rawFile.status == 0)
            {
                var allText = rawFile.responseText;
                alert(allText);
            }
        }
    }
    rawFile.send(null);
}
async onClickSave(){

  console.log("PPPPP")
  console.log(this.state.categoryChanged)
  var options = {
     method: "patch",
     credentials: "same-origin",
     headers: {
       "Authorization": localStorage.getItem("Authorization") ,
       "Accept": "application/json",
       "Content-Type": "application/json"},
     proxy: {
       host: 'localhost:8000',
       port: 8000
     }
   }
   // id : i,
   // title : item.titulo,
   // author: author ,
   // date:date,
   // pseudo: item.pseudonimo,
   // code:item.code,
   // // date:'',
   // category:item.genero.nombre,
   // pdf:item.pdf
   // console.log(document.getElementById("inputPseudo").value)
   var playChanged={}
   
     playChanged={
       titulo: document.getElementById("inputTitle").value,
       genero:this.state.categoryChanged? this.state.categoryChanged:this.state.record.categoryObj.id,
       pseudonimo: document.getElementById("inputPseudo").value
     }

     
     
   
   await axios.patch(`https://back.premiocasa.cult.cu/api/musica/obra/${this.state.record.id}/`, playChanged, options)
   .then(
     (response) => {
       console.log(response);
       if(response.status === 200)
          window.location.reload()
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        });
        }
     },
     (error) => {
       console.log(error);
     }
   ).catch((err) => console.log(err))
   
 }
  async onClickSave2(field,index,id){
   var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    // id : i,
    // title : item.titulo,
    // author: author ,
    // date:date,
    // pseudo: item.pseudonimo,
    // code:item.code,
    // // date:'',
    // category:item.genero.nombre,
    // pdf:item.pdf
    // console.log(document.getElementById("inputPseudo").value)
    var playChanged={}
    if(field=="title"){
      playChanged={
        titulo: document.getElementById(field+index).value
      }
    }
   
    if(field=="category"){
      console.log("SALSAAAA")
      console.log(this.state.categoryChanged)
      console.log(document.getElementById(field+index))
      playChanged={
        genero: this.state.categoryChanged
      }
    }
    if(field=="pseudo"){
      playChanged={
        pseudonimo: document.getElementById(field+index).value
      }
    }
    
    await axios.patch(`https://back.premiocasa.cult.cu/api/musica/obra/${id}/`, playChanged, options)
    .then(
      (response) => {
        console.log(response);
        if(response.status === 200)
          window.location.reload();
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        });
        }
        
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
    
  }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
              <Input className='music-input'
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.onClickArticle(record)} >{a.name}</a> </li>})}</ol> )
              || (<a onClick = {()=>this.onClickArticle(record)} >  {text}</a> )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        console.log("handle")
        console.log(selectedKeys[0])
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
      onDocumentLoadSuccess({ numPages }) {
        this.setState({ numPages: numPages});
      };
      getDataFromURL = (url) => new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

    async logout(){
      await fetch('https://back.premiocasa.cult.cu/api/logout',{
        method: "post",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"
      },
      }).then(result=>{
        if(result.status == 200){
          localStorage.clear()
          window.location.reload(); 
        }
        else{
          notification.error({
        message:'Error',
        description:'Hubo un error, por favor intente más tarde',
      })}
      })
    }
    // onClickEdit=(field,index)=>{
    //   this.setState({edit:true})
    //   if(field=="title"){
    //     this.setState({editTitle:true})
    //   }
    //   if(field=="author"){
    //     var newIndexs =[...this.state.editAuthorIndex,index] 
    //     this.setState({editAuthor:true,editAuthorIndex:newIndexs})
    //   }
    //   if(field=="category"){
    //     this.setState({editCategory:true})
    //   }
    //   if(field=="pseudo"){
    //     this.setState({editPseudo:true})
    //   }
    // }
   
    getCountryCode(country){
      for(var c in  countries["countries"]){
        if (countries["countries"][c]["name_es"]==country)
          return countries["countries"][c]["code"]
      }
      return "No code"
    }
  render() {
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays,"read")

    const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays,"save",true)
    const readPlayReportGenre =()=> generatePDFPlay(this.state.plays,"read",true)

    const downloadCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"read")

    const downloadConcReport =()=> generatePDFConc(this.state.conc,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

const downloadPlayReportGenreS =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"save")
const readPlayReportGenreS =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"read")


const onClickGenreReport=()=>{
  this.setState({makeGenreReport:true})
}
const onClosekGenreReport=()=>{
  this.setState({makeGenreReport:false})
}
const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


const onClickCountryReport=()=>{
  this.setState({makeCountryReport:true})
}
const onClosekCountryReport=()=>{
  this.setState({makeCountryReport:false})
}
const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}

   
    const location = window.location;
    // console.log(location.pathname)
    const centerStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignElements:'center',
    };
      const { Header, Footer, Content } = Layout;
      const Moment = require('moment');
      const columns = [
                
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
                    dataIndex: 'code',
                    key: 'code',
                    // sorter: (a, b) => a.code.localeCompare(b.code),
                    width:'8%',
                    // sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('code','número'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    sorter: (a, b) => a.title.localeCompare(b.title),
                    // sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
                    dataIndex: 'pseudo',
                    key: 'pseudo',
                    // sorter: (a, b) => a.title.localeCompare(b.title),
                    // sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('pseudo','seudónimo'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Autor(es)</div>,
                    dataIndex: 'author',
                    key: 'author',
                    // sorter: (a, b) => a.author.localeCompare(b.author),
                    // sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('author','autor'),
                    responsive: ['sm'] 
                  },
                  
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
                    dataIndex: 'date',
                    key: 'date',
                    width:'8%',
                    // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('date','fecha'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'5%',
                    // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
                    render: (text,record) =>(
                      <div  style={{fontSize:'large' }}>
                      <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                      </div>
          ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                    
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large' }}>Obra</div>,
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('name','nombre'),
                    render: (record) => (
                      <React.Fragment>
                        <a onClick = {()=>this.onClickArticle(record)} >   
                        <b style={{fontSize:'large'}}>{record.title}</b>
                        </a>

                        <br />
                        <b>Código:</b>{record.code}
                        <br />
                        <b>Seudónimo:</b>{record.pseudo}
                        <br />
                        <b>Autor(es):</b><ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> 
                        <b>Género:</b>{record.category}
                        <br />
                        <b>Fecha:</b>{record.date}
                      </React.Fragment>
                    ),
                    responsive: ['xs'] 
                  },
                  {
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'15%',
                    render: (text,record) =>(
                                <div  style={{fontSize:'large' }}>
                                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                                </div>
                    ),
                    // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['xs'] 
                  },


                
                
            ];
            // console.log(this.state.record.pdf);
    const content=(
      <div>{this.state.record  &&
      <Button key="back"> <ReadOutlined /><a href={this.state.record.pdf} target="_blank">Read</a></Button>&&
      <Button key="back" > <DownloadOutlined />Download</Button>}

      </div>

    );
    const url = this.state.record?.pdf
    const downloadUrl = this.state.record?.pdf

    const readFile =  ()=>{
      // fetch(this.state.record.pdf).then(r=> console.log( this.state.record.pdf));
      
      console.log(this.state.record?.pdf)
      window.open(url)
    };
    const downloadFile=()=>{
      fetch(downloadUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/zip"
        }
      })
        .then(res => res.blob())
        .then(response => {
          //Create a Blob from the PDF Stream
          console.log(response);
          const blob = new Blob([response], {
            type: "application/zip",
            
          });
          //Build a URL from the file
          // const fileURL = URL.createObjectURL(file);

          const link = document.createElement('a');
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = this.state.record.code +'.zip';
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          setTimeout(() => URL.revokeObjectURL(link.href), 7000);
          //Open the URL on new Window
          // window.open(fileURL);
        })
        .catch(error => {
          console.log(error);
        });
    }

    const openpdf=()=>{
      // var rawFile = new XMLHttpRequest();
      // rawFile.open("GET", this.state.record?.pdf, true);
      // console.log(this.state.record?.pdf)
      // console.log(rawFile)
      // rawFile.overrideMimeType('application/pdf')
      // rawFile.send(null)

      // rawFile.onreadystatechange = function ()
      // {
      //     if(rawFile.readyState === 4)
      //     {
      //       console.log("aaaaa")
      //         if(rawFile.status === 200 || rawFile.status == 0)
      //         {
      //           console.log("bbbbbb")
      //           var blob = new Blob([rawFile.response], { type: 'application/pdf' });
      //           var link = window.URL.createObjectURL(blob)
      //           window.open(link)
      //         }
      //         else
      //         console.log("errorrrrr")
      //     }
      // }


      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf"
          
        },
        responseType: 'arraybuffer'
        
      })
        .then(res => res.blob())
        .then(response => {
        //   axios({
        //     method: 'get',
        //     url: file[0].preview, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
        //     responseType: 'blob'
        // }).then(function(response){
        //      var reader = new FileReader();
        //      reader.readAsDataURL(response.data); 
        //      reader.onloadend = function() {
        //          var base64data = reader.result;
        //          self.props.onMainImageDrop(base64data)
        //      }
    
        // })

          //Create a Blob from the PDF Stream
          console.log(response);
          const blob = new Blob([response], {
            type: "application/pdf"
          });
          console.log(blob)
          //Build a URL from the file
          // const fileURL = URL.createObjectURL(file);

          // create a blobURI pointing to our Blob
          var link = URL.createObjectURL(blob);
          return link
          // link.download = this.state.record.code;
          // some browser needs the anchor to be in the doc
          // document.body.append(link);
          // link.click();
          // link.remove();
          // // in case the Blob uses a lot of memory
          // setTimeout(() => URL.revokeObjectURL(link.href), 7000);
          //Open the URL on new Window
          // window.open(fileURL);
        })
        .catch(error => {
          console.log(error);
        });
    }
    const { SubMenu } = Menu;
    const { Option } = Select;
    const menu = (
      <Menu  style={{height:'140'}} mode="inline">
      <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
      <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin"> Inicio</NavLink>
      </Menu.Item>
      <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
      <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin_plays_list"> Obras</NavLink>
      </Menu.Item>
      <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
      <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/musicologia/admin_conc_list'> Concursantes  </NavLink>
      </Menu.Item>
      <SubMenu key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
          <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
             
                  
                  <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
                    <Menu.Item>
                        <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
                    </Menu.Item>
                  </Menu.ItemGroup>

               
                   
                  <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
                    <Menu.Item>
                        <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
                    </Menu.Item>
                  </Menu.ItemGroup>
                  <Menu.Item>
                    <h4 onClick={onClickCountryReport}  style={{  color:'black'}}>Por país específico</h4>
                  </Menu.Item>

                
          </SubMenu>
          <SubMenu  key="conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
            <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>
        
            
         
        
       
      </SubMenu>
      <SubMenu disabled key="jury" icon={<TeamOutlined  style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Jurado">
            <Menu.Item>
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado'> Todo  </NavLink>
            </Menu.Item>
            <Menu.Item>
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado_poe'> Poesía  </NavLink>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado_nov'> Novela  </NavLink>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado_ens'> Ensayo  </NavLink>
            </Menu.Item>
         </SubMenu>
      <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
      <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold'}}> Cerrar sesión </a>
      </Menu.Item>
        
      </Menu>
    )
    return (

      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
      <Layout style={{backgroundColor:'white'}}>
                <Row>
                  <Col><NavLink to="/musicologia"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
                
                </Row>
                
                <Row>
                  <Col span={24}>
                  <Navbar menu={menu}/>
      
                  
                  </Col>
                </Row>
            <Content>
              <Row>
                <Col span={24}>
                <Table
                  bordered
                  columns={columns}
                  dataSource= {this.state.plays}
                  pagination={{ position: ["bottomCenter"],}} 
                  tableLayout='fixed'
                  size='small'
                  style={{ whiteSpace: 'normal'}}
                  size="small"
                  onChange = {this.handleTableChange}
                />
                
                    
                </Col>
              </Row>
              {
                    this.state.showArticle && 
                    <Modal 
                        closable = {false}
                        title={ this.state.record.code}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                          
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                             
                        ]}
                        >
                       
                        {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}

                         <p><FileTextOutlined />Título: {this.state.record.title}</p>
                        
                        <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                        <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>

                       
                        
                        <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>

                        
                        <p>

                          <Button onClick={downloadFile} >
                          <FilePdfOutlined/>  Descargar Zip
                            </Button>
                        </p>

                    </Modal>
                    

                    || (this.state.edit && 
                      <Modal 
                          closable = {false}
                          title={ this.state.record.code}
                          visible={this.state.edit} 
                          onCancel={this.hideEdit}
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                         
                         {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}
  
                           <p><FileTextOutlined />Título: <Input className='music-input' style={{width:'80%'}} defaultValue={this.state.record.title} id ="inputTitle" /></p>
                          
                          <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                          <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
  
                         
                          
                          <p><AuditOutlined />Seudónimo: <Input className='music-input' defaultValue={this.state.record.pseudo}style={{width:'70%'}} id="inputPseudo"/></p>
                          <p>
  
                            <Button onClick={downloadFile} >
                            <FilePdfOutlined/>  Descargar Zip
                              </Button>
                          </p>
  
                      </Modal>)
                      }
           
              {this.state.makeCountryReport &&
              <Modal
              closable = {false}
              title="Reporte por país"
              visible={this.state.makeCountryReport}
              footer={[
                <Button key="back" onClick={onClosekCountryReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportCountry}
                   onChange={onChangeReportCountry}
                   >
                    {[...this.countries].map(c => {return <Option value={c}>{c}</Option>})}
                  </Select>
                  <div>
                    <br/>
                    <Button onClick={readPlayReportSelectedCountry}>Ver</Button> <Button onClick={downloadPlayReportSelectedCountry}>Descargar</Button>
                  </div>
              </Modal>}
            </Content>
          </Layout>
         
        </ConfigProvider>
    </div>
    <Footer style={{backgroundColor:'#ed7e8e', position:'relative',bottom:'0px',left:'0px',right:'0px'}}>
          
        <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#ed7e8e',  marginBottom:'0px', bottom:'0px'}}>
            <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/musicologia/admin_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
            <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a></div></Col>
            <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
            <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
            <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/musicologia/admin_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
        </Row>
    </Footer>
    </div>

    );
  }
}
export default Playslist;


